import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

/**
 * Rendered markdown surface for AI outputs (plans, execute results, etc.).
 * Tailwind classes provide reasonable defaults — headings, lists, code,
 * tables (via GFM). Keep it boring; the content is the focus.
 */
export function Markdown({
  children,
  className,
}: {
  children: string;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none',
        // Tailwind doesn't ship typography by default; tune common element
        // styles inline so we don't need the plugin.
        '[&_h1]:text-xl [&_h1]:font-semibold [&_h1]:mt-4 [&_h1]:mb-2',
        '[&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mt-3 [&_h2]:mb-2',
        '[&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-3 [&_h3]:mb-1',
        '[&_p]:my-2 [&_p]:leading-relaxed',
        '[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:my-2',
        '[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:my-2',
        '[&_li]:my-0.5',
        '[&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs',
        '[&_pre]:bg-muted [&_pre]:p-3 [&_pre]:rounded [&_pre]:overflow-x-auto [&_pre]:text-xs',
        '[&_pre_code]:bg-transparent [&_pre_code]:p-0',
        '[&_blockquote]:border-l-2 [&_blockquote]:border-muted [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground',
        '[&_a]:text-primary [&_a]:underline',
        '[&_table]:my-3 [&_table]:text-sm',
        '[&_th]:text-left [&_th]:font-medium [&_th]:px-2 [&_th]:py-1 [&_th]:border-b',
        '[&_td]:px-2 [&_td]:py-1 [&_td]:border-b [&_td]:border-muted',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
